// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../styles/colors.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../styles/helpers.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__contentContainer___G92hh {
  display: block;
  padding-bottom: 20px;
  padding-top: 20px;
}

.styles__cardMarginBot___N5KIC {
}

.styles__oneThird___XK4pW {
  width: calc(99.9% * 1/3 - (30px - 30px * 1/3));
}

.styles__oneThird___XK4pW:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.styles__oneThird___XK4pW:last-child {
  margin-right: 0;
}

.styles__oneThird___XK4pW:nth-child(3n) {
  margin-right: 0;
  float: right;
}

.styles__oneThird___XK4pW:nth-child(3n + 1) {
  clear: both;
}

@media only screen and (max-width: 768px) {

.styles__oneThird___XK4pW {
    width: calc(99.9% * 1/1 - (30px - 30px * 1/1));
}

.styles__oneThird___XK4pW:nth-child(1n) {
    float: left;
    margin-right: 30px;
    clear: none;
}

.styles__oneThird___XK4pW:last-child {
    margin-right: 0;
}

.styles__oneThird___XK4pW:nth-child(1n) {
    margin-right: 0;
    float: right;
}

.styles__oneThird___XK4pW:nth-child(1n + 1) {
    clear: both;
}
  }

.styles__twoThird___pd3cL {
  width: calc(99.9% * 2/3 - (30px - 30px * 2/3));
}

.styles__twoThird___pd3cL:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.styles__twoThird___pd3cL:last-child {
  margin-right: 0;
}

.styles__twoThird___pd3cL:nth-child(3n) {
  margin-right: 0;
  float: right;
}

.styles__twoThird___pd3cL:nth-child(3n + 1) {
  clear: both;
}

@media only screen and (max-width: 768px) {

.styles__twoThird___pd3cL {
    width: calc(99.9% * 1/1 - (30px - 30px * 1/1));
}

.styles__twoThird___pd3cL:nth-child(1n) {
    float: left;
    margin-right: 30px;
    clear: none;
}

.styles__twoThird___pd3cL:last-child {
    margin-right: 0;
}

.styles__twoThird___pd3cL:nth-child(1n) {
    margin-right: 0;
    float: right;
}

.styles__twoThird___pd3cL:nth-child(1n + 1) {
    clear: both;
}
  }

.styles__row___kbDCX {
}

.styles__body___NWufH {
  display: flex;
}

.styles__titleBox___HLNkZ {
}

.styles__statusActive___my5Gb {
}

.styles__statusPending___fXLrp {
}

.styles__statusRejected___byFYG {
}

.styles__nameWrapper___yqNES {
  width: calc(99.9% * 3/5 - (30px - 30px * 3/5));
}

.styles__nameWrapper___yqNES:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.styles__nameWrapper___yqNES:last-child {
  margin-right: 0;
}

.styles__nameWrapper___yqNES:nth-child(5n) {
  margin-right: 0;
  float: right;
}

.styles__nameWrapper___yqNES:nth-child(5n + 1) {
  clear: both;
}

.styles__nameWrapper___yqNES .styles__boxLabel___F_27s {
    margin-right: 20px;
  }

.styles__balanceWrapper___uReQD {
  width: calc(99.9% * 2/5 - (30px - 30px * 2/5));
  text-align: right;
}

.styles__balanceWrapper___uReQD:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.styles__balanceWrapper___uReQD:last-child {
  margin-right: 0;
}

.styles__balanceWrapper___uReQD:nth-child(5n) {
  margin-right: 0;
  float: right;
}

.styles__balanceWrapper___uReQD:nth-child(5n + 1) {
  clear: both;
}

.styles__actionButton___BIp6n {
  background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]};
  color: white;
  line-height: 19px;
  margin: 0 10px;
  width: auto;
}

.styles__actionButton___BIp6n:hover {
    background-color: rgba(55, 110, 161, 0.9);
  }

.styles__actions___qePlR {
  justify-content: space-between;
}

.styles__buttonSecondary___A6MI9 {
  margin-bottom: 10px;
  text-align: center;
  width: 100%;
}

.styles__buttonSecondary___A6MI9:last-child {
    margin-bottom: 0;
  }

.styles__label___DQeFH {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]};
  font-size: 10px;
  margin-bottom: 2px;
}

.styles__updated___iiaHu {
  display: block;
  margin-top: 10px;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./universal/routes/Protected/Beneficiary/components/Show/styles.css"],"names":[],"mappings":"AAIA;EAEE,cAAc;EACd,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;AAEA;;AAEA;EACE,8CAAgB;AAKlB;;AANA;EACE,WAAgB;EAAhB,kBAAgB;EAAhB,WAAgB;AAKlB;;AANA;EACE,eAAgB;AAKlB;;AANA;EACE,eAAgB;EAAhB,YAAgB;AAKlB;;AANA;EACE,WAAgB;AAKlB;;AAHE;;AAHF;IAII,8CAAkB;AAEtB;;AANA;IAII,WAAkB;IAAlB,kBAAkB;IAAlB,WAAkB;AAEtB;;AANA;IAII,eAAkB;AAEtB;;AANA;IAII,eAAkB;IAAlB,YAAkB;AAEtB;;AANA;IAII,WAAkB;AAEtB;EADE;;AAGF;EACE,8CAAgB;AAKlB;;AANA;EACE,WAAgB;EAAhB,kBAAgB;EAAhB,WAAgB;AAKlB;;AANA;EACE,eAAgB;AAKlB;;AANA;EACE,eAAgB;EAAhB,YAAgB;AAKlB;;AANA;EACE,WAAgB;AAKlB;;AAHE;;AAHF;IAII,8CAAkB;AAEtB;;AANA;IAII,WAAkB;IAAlB,kBAAkB;IAAlB,WAAkB;AAEtB;;AANA;IAII,eAAkB;AAEtB;;AANA;IAII,eAAkB;IAAlB,YAAkB;AAEtB;;AANA;IAII,WAAkB;AAEtB;EADE;;AAGF;AAEA;;AAEA;EACE,aAAa;AACf;;AAEA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;EACE,8CAAgB;AAKlB;;AANA;EACE,WAAgB;EAAhB,kBAAgB;EAAhB,WAAgB;AAKlB;;AANA;EACE,eAAgB;AAKlB;;AANA;EACE,eAAgB;EAAhB,YAAgB;AAKlB;;AANA;EACE,WAAgB;AAKlB;;AAHE;IACE,kBAAkB;EACpB;;AAGF;EACE,8CAAgB;EAChB,iBAAiB;AACnB;;AAHA;EACE,WAAgB;EAAhB,kBAAgB;EAAhB,WAAgB;AAElB;;AAHA;EACE,eAAgB;AAElB;;AAHA;EACE,eAAgB;EAAhB,YAAgB;AAElB;;AAHA;EACE,WAAgB;AAElB;;AAEA;EACE,wDAAkB;EAClB,YAAY;EAEZ,iBAAiB;EACjB,cAAc;EACd,WAAW;AAKb;;AAHE;IACE,yCAAyC;EAC3C;;AAGF;EAEE,8BAA8B;AAChC;;AAEA;EAEE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AAKb;;AAHE;IACE,gBAAgB;EAClB;;AAGF;EACE,mDAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb","sourcesContent":["@value helpers: 'styles/helpers.css';\n@value colors: 'styles/colors.css';\n@value gtBlue, textLight from colors;\n\n.contentContainer {\n  composes: content-container from helpers;\n  display: block;\n  padding-bottom: 20px;\n  padding-top: 20px;\n}\n\n.cardMarginBot {\n  composes: cardMarginBot from helpers;\n}\n\n.oneThird {\n  lost-column: 1/3;\n\n  @media only screen and (max-width: 768px) {\n    lost-column: 1 / 1;\n  }\n}\n\n.twoThird {\n  lost-column: 2/3;\n\n  @media only screen and (max-width: 768px) {\n    lost-column: 1 / 1;\n  }\n}\n\n.row {\n  composes: row from helpers;\n}\n\n.body {\n  display: flex;\n}\n\n.titleBox {\n  composes: sectionSmall row from helpers;\n}\n\n.statusActive {\n  composes: statusActive from helpers;\n}\n\n.statusPending {\n  composes: statusPending from helpers;\n}\n\n.statusRejected {\n  composes: statusRejected from helpers;\n}\n\n.nameWrapper {\n  lost-column: 3/5;\n\n  .boxLabel {\n    margin-right: 20px;\n  }\n}\n\n.balanceWrapper {\n  lost-column: 2/5;\n  text-align: right;\n}\n\n.actionButton {\n  background: gtBlue;\n  color: white;\n  composes: button from helpers;\n  line-height: 19px;\n  margin: 0 10px;\n  width: auto;\n\n  &:hover {\n    background-color: rgba(55, 110, 161, 0.9);\n  }\n}\n\n.actions {\n  composes: clearfix section row from helpers;\n  justify-content: space-between;\n}\n\n.buttonSecondary {\n  composes: buttonSecondary from helpers;\n  margin-bottom: 10px;\n  text-align: center;\n  width: 100%;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n}\n\n.label {\n  color: textLight;\n  font-size: 10px;\n  margin-bottom: 2px;\n}\n\n.updated {\n  display: block;\n  margin-top: 10px;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpers": `'styles/helpers.css'`,
	"colors": `'styles/colors.css'`,
	"gtBlue": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]}`,
	"textLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]}`,
	"contentContainer": `styles__contentContainer___G92hh ${___CSS_LOADER_ICSS_IMPORT_1___.locals["content-container"]}`,
	"cardMarginBot": `styles__cardMarginBot___N5KIC ${___CSS_LOADER_ICSS_IMPORT_1___.locals["cardMarginBot"]}`,
	"oneThird": `styles__oneThird___XK4pW`,
	"twoThird": `styles__twoThird___pd3cL`,
	"row": `styles__row___kbDCX ${___CSS_LOADER_ICSS_IMPORT_1___.locals["row"]}`,
	"body": `styles__body___NWufH`,
	"titleBox": `styles__titleBox___HLNkZ ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionSmall"]} ${___CSS_LOADER_ICSS_IMPORT_1___.locals["row"]}`,
	"statusActive": `styles__statusActive___my5Gb ${___CSS_LOADER_ICSS_IMPORT_1___.locals["statusActive"]}`,
	"statusPending": `styles__statusPending___fXLrp ${___CSS_LOADER_ICSS_IMPORT_1___.locals["statusPending"]}`,
	"statusRejected": `styles__statusRejected___byFYG ${___CSS_LOADER_ICSS_IMPORT_1___.locals["statusRejected"]}`,
	"nameWrapper": `styles__nameWrapper___yqNES`,
	"boxLabel": `styles__boxLabel___F_27s`,
	"balanceWrapper": `styles__balanceWrapper___uReQD`,
	"actionButton": `styles__actionButton___BIp6n ${___CSS_LOADER_ICSS_IMPORT_1___.locals["button"]}`,
	"actions": `styles__actions___qePlR ${___CSS_LOADER_ICSS_IMPORT_1___.locals["clearfix"]} ${___CSS_LOADER_ICSS_IMPORT_1___.locals["section"]} ${___CSS_LOADER_ICSS_IMPORT_1___.locals["row"]}`,
	"buttonSecondary": `styles__buttonSecondary___A6MI9 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["buttonSecondary"]}`,
	"label": `styles__label___DQeFH`,
	"updated": `styles__updated___iiaHu`
};
export default ___CSS_LOADER_EXPORT___;
